import { useAudioInput } from '@/hooks/useAudioInput'

export default function AudioInputMonitor() {
  const { devices, selectedDeviceId, selectDevice, level, isMonitoring, error, retry } = useAudioInput()

  // Safari will not open the mic without a user gesture, and re-blocks it when
  // the tab loses focus. Both used to leave this component rendering nothing at
  // all, so the meter simply vanished with no way back — offer the retry.
  if (error || !isMonitoring) {
    return (
      <button
        onClick={retry}
        className="flex w-full items-center gap-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-700 transition hover:bg-amber-100 min-h-[40px]"
      >
        <span aria-hidden>🎤</span>
        <span className="flex-1 text-left">{error ?? 'Microphone is off'}</span>
        <span className="font-semibold underline">Turn on</span>
      </button>
    )
  }

  return (
    <div className="flex items-center gap-3 bg-accent/50 rounded-lg px-3 py-2">
      <span className="text-muted-foreground text-sm shrink-0">🎤</span>

      {devices.length > 1 ? (
        <select
          value={selectedDeviceId ?? ''}
          onChange={(e) => selectDevice(e.target.value)}
          className="text-sm bg-transparent border-none outline-none text-foreground min-w-0 flex-1 truncate cursor-pointer"
        >
          {devices.map((d) => (
            <option key={d.deviceId} value={d.deviceId}>
              {d.label}
            </option>
          ))}
        </select>
      ) : (
        <span className="text-sm text-muted-foreground min-w-0 flex-1 truncate">
          {devices[0]?.label ?? 'Microphone'}
        </span>
      )}

      <div className="w-24 h-3 bg-background rounded-full overflow-hidden shrink-0 border border-border">
        <div
          className="h-full rounded-full transition-[width] duration-75"
          style={{
            width: `${Math.min(level * 100 * 3, 100)}%`,
            backgroundColor: level > 0.15 ? '#22c55e' : level > 0.05 ? '#eab308' : '#d1d5db',
          }}
        />
      </div>
    </div>
  )
}
